module.exports = __webpack_public_path__ + "img/No-Insurance-shield.ca963001.png";